import WRAP from "WRAP-JS";
import LegendNavaids from "../legend/LegendNavaids";
import {
  configNavaidsDh,
  configNavaidsLayer
} from "./config/ConfigNavaids";
import { MAP_ID_NAVAIDS } from "../../../store/MapContentsState";

class Navaids {
  static NAME = MAP_ID_NAVAIDS;
  static VOR_NAME = Navaids.makeContentsKey('VOR');
  static VOR_DME_NAME = Navaids.makeContentsKey('VORDME');
  static VOR_TAC_NAME = Navaids.makeContentsKey('VORTAC');
  static TACAN_NAME = Navaids.makeContentsKey('TACAN');
  static NDB_NAME = Navaids.makeContentsKey('NDB');

  contentsVisibleState = {
    [Navaids.VOR_NAME]: true,
    [Navaids.VOR_DME_NAME]: true,
    [Navaids.VOR_TAC_NAME]: true,
    [Navaids.TACAN_NAME]: true,
    [Navaids.NDB_NAME]: true,
  };

  dhNavaids;
  layerNavaids;
  visible;
  ready = false;

  constructor() {
    this.layerNavaids = new WRAP.Geo.Layer(Navaids.NAME);
    this.layerNavaids.setVisible(false);
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.ready = true;
  }

  initData() {
    this.dhNavaids = new WRAP.Data(configNavaidsDh);
  }

  initLayer() {
    this.layerNavaids.configure(this.dhNavaids, configNavaidsLayer);

    this.layerNavaids.setTooltip(geo => {
      return `${geo.properties.ident} / ${geo.properties.name}`;
    });

    this.layerNavaids.setAttributes({
      filter: this._visibleFilter.bind(this)
    });
  }

  async drawLayer(visible) {
    this.visible = visible;
    if (!this.dhNavaids) {
      await this.initialize();
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return [this.layerNavaids];
  }

  setVisible(visible, contents) {

    if (contents) {
      this.contentsVisibleState[contents] = visible;
      this.layerNavaids.invalidate();
    } else {
      if(visible) {
        this.layerNavaids.show();
      } else {
        this.layerNavaids.hide();
      }
    }
  }

  getLegend() {
    return {
      id: Navaids.NAME,
      label: 'Navaids',
      component: LegendNavaids,
      contents: this
    };
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  _visibleFilter(feature) {
    return this.contentsVisibleState[ Navaids.makeContentsKey(feature.properties.kind) ];
  }

  static makeContentsKey(kind) {
    return `${Navaids.NAME}_${kind}`;
  }
}

export default Navaids;